<ng-template #WarnPopup let-c="close" let-d="dismiss" class="el--popup">
    <app-custom-modal [hideCross]="hideCross" (oncrossBtnClick)="c('close');okButton ? closeEvent(true, true): (okayFinalButton || closeButton) ? closeEvent(false) : patchQtyDisp(null)">
        <h4 header>
            {{IsHeaderText ? IsHeaderText : 'Warning!!'}} </h4>
        <div body>
            <span [innerHTML]="warnMsg"></span>
            <span  class="text-center" *ngIf="eyconDPVDocsExist"><div><br></div>
                <input class="form-check-input margin_top_0_3rem" type="checkbox" [(ngModel)]="removeEyeconImages" id="removeEyeconImagesCheckbox"/>
                <label class="color_black label-weight" for="removeEyeconImagesCheckbox">
                    Remove <b>Drug Pick</b> Verified Images
                </label>
            </span><div *ngIf="displayPaidTransMsg"><br></div>
            <div class="color_orange font_size_1_2rem transfer-out-msg" *ngIf="displayPaidTransMsg">
                <b>Note: {{msgConfig?.POS_Paid_Transaction_Msg}}</b>
            </div>
            <div *ngIf="includePath">
                <div class="mb-2 pdmpInformation-msg">
                    <div class="padding_0_5rem">
                        <span class="text_color_black">
                            <i class="info-medium--font far fa-info-circle text_color_black"></i>
                            Navigation:
                        </span>
                        <span class="text-color-blue">Security Manager</span>&nbsp;
                        <i class="far fa-angle-right font_size--1rm text_color_black"></i>&nbsp;
                        <span class="text-color-blue">Users</span>&nbsp;
                        <i class="far fa-angle-right font_size--1rm text_color_black"></i>&nbsp;
                        <span class="text-color-blue">Edit Users</span>
                    </div>
                </div>
            </div>
        </div>
            <button ngbAutofocus  *ngIf="okButton" id="focuschange" footer   type="submit" class="hotkey_primary" appShortcutKey (click)="c('close')" 
            (click)="closeEvent(true)" (keydown.enter)="closeEvent(true)" InputKey="o"><b>O</b> OK
        </button>
        <button *ngIf="okayFinalButton" id="focuschange" footer   type="submit" class="hotkey_primary" appShortcutKey (click)="c('close')"
        (click)="closeEvent(false)" (keydown.enter)="closeEvent(false)" InputKey="o"><b>O</b> OK
        </button>
        <!-- <button *ngIf="okButton" footer autofocus  type="submit" class="hotkey_primary" appShortcutKey (click)="c('close')"
            (click)="closeEvent(true)" (keydown.enter)="closeEvent(true)" InputKey="o"><b>o</b> Ok
        </button> -->
        <button class="hotkey_primary" type="submit"  footer *ngIf="yesButton"  ngbAutofocus appShortcutKey InputKey="y" (click)="patchQtyDisp(true)">
            <b>Y</b>YES
        </button>
        <button class="hotkey_primary"   type="submit" footer *ngIf="noButton"  appShortcutKey InputKey="n" (click)="patchQtyDisp(false)">
            <b>N</b>NO
        </button>
        <button class="hotkey_primary" type="submit"  footer *ngIf="recallButton"  ngbAutofocus appShortcutKey InputKey="r" (click)="closeEvent(true)">
            <b>R</b>RECALL DELETED RX
        </button>
        <button class="hotkey_primary"   type="submit" footer *ngIf="closeButton"  appShortcutKey InputKey="c" (click)="closeEvent(false)">
            <b>C</b>CLOSE
        </button>
        <button class="hotkey_primary" appTooltip="Defer with future effective date as due date"  type="submit" footer *ngIf="Defer"  appShortcutKey InputKey="d" (click)="closeEvent('defer')">
            <b>D</b>DEFER
        </button>
        <button class="inactive" appTooltip="Defer with future effective date as due date"  type="submit" footer *ngIf="Defer === false"  appShortcutKey InputKey="d" > <b>D</b>
           DEFER
        </button>
        <button class="hotkey_primary"   type="submit" footer appTooltip="Ignore effective date and Process Today" *ngIf="IgnoreAndContinue"  appShortcutKey InputKey="i" (click)="closeEvent('ignoreAndContinue')">
            <b>I</b>IGNORE AND PROCESS
        </button>
        <button class="hotkey_primary" type="submit"  footer *ngIf="buttonType"  ngbAutofocus appShortcutKey InputKey="{{shortcutKey}}" (click)="closeEvent(true)">
            <b>{{shortcutKey | uppercase}}</b> {{buttonType}}
        </button>
        <button class="hotkey_primary"  id="DenyButton"  type="submit" footer *ngIf="DenyButton"  appShortcutKey InputKey="d" (click)="closeEvent('deny')">
            <b>D</b>Deny
        </button>        
        <button class="hotkey_primary"  id="CancelButton"  type="submit" footer *ngIf="CancelButton"  appShortcutKey InputKey="c" (click)="closeEvent('cancel')">
            <b>C</b>CANCEL
        </button>        
    </app-custom-modal>
</ng-template>

<ng-template #PAErrorMessage let-c="close" let-d="dismiss" class="el--popup">
    <div class="main_error_block">
        <i class="far fa-times float-end" aria-hidden="true" (click)="c('Close click');closeEvent(true)"></i>
        <div class="pt-2">The following fields are required to initiate PA request for Rx# : {{RxNum}}</div>
        <div *ngFor="let error of warnMsg">
            <span class="error_msg_text">{{error}}</span>
        </div>
        <div>Please enter those fields and try again.</div>
    </div>
</ng-template>

<ng-template #CommonErrorMessage let-c="close" let-d="dismiss" class="el--popup">
    <div class="main_error_block">
        <i class="far fa-times float-end" aria-hidden="true" (click)="c('Close click');closeEvent(true)"></i>
        <div >
            <span style="display: inline-flex; align-items: center;"><i style="font-size: 2.5rem; color: #cc0033;" class="far fa-times-circle cursor-pointer" aria-hidden="true" (click)="closeEvent(true)"></i>
                <span class="pt-1 ps-3">Error : {{warnMsg}}</span>
            </span>            
        </div>
    </div>
</ng-template>
